var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('p',[_vm._v("\n    Copyright  ©  广州市金界电子设备有限公司   \n    "),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn"}},[_vm._v("粤ICP备19060835号-1")])]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a4e779f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_footer.vue
// module id = null
// module chunks = 